import { useAuth } from '@clerk/clerk-react';
import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import type { OrganizationSubscriptionInvoiceItemDto } from '@/types/dtos/transactions/subscription-invoice.dto';

export function organizationSubscriptionInvoicesQueryKey(organizationId: string) {
  return ['transactions', 'organization', organizationId, 'subscription-invoices'] as const;
}

export function useOrganizationSubscriptionInvoicesQuery(organizationId: string | undefined) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: organizationId
      ? organizationSubscriptionInvoicesQueryKey(organizationId)
      : ['transactions', 'subscription-invoices', 'idle'],
    enabled: !!organizationId,
    queryFn: async (): Promise<OrganizationSubscriptionInvoiceItemDto[]> => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/transactions/organization/${organizationId}/subscription-invoices`;
      return sendJSONRequest({
        url,
        method: METHOD.GET,
        token: token ?? '',
      }) as Promise<OrganizationSubscriptionInvoiceItemDto[]>;
    },
  });
}
